// id for ReadingAidsPopup portal container
export const READING_AIDS_POPUP_PORTAL_CONTAINER =
	'editor-ai-definitions-reading-aids-popup-portal-container';

// css class for keyword decoration
export const KEYWORD_DECORATION_CLASS = 'ai-definitions-keyword-decoration';
// css class for keyword decoration styler
export const KEYWORD_STYLER_CLASS = 'ai-definitions-keyword-styler';
export const KEYWORD_STYLER_HOVER_CLASS = 'ai-definitions-keyword-styler-hover';
export const KEYWORD_STYLER_ACTIVE_CLASS = 'ai-definitions-keyword-styler-active';
